import { useState } from 'react'
import * as S from './styles'

type OnClickItemType = (index: string) => void

export type ItemActionTabsType = {
  label: string
  onClick: OnClickItemType
}

type ActionTabsProps = {
  items: ItemActionTabsType[]
  currentItem: string
  disabled?: boolean
}

export const ActionTabs = ({ items, currentItem, disabled }: ActionTabsProps) => {
  const [selected, setSelected] = useState<number>(+currentItem)

  const handleSelected = (index: string, callback: OnClickItemType) => {
    setSelected(+index)
    callback(index)
  }

  return (
    <S.ActionTabsWrap id="action-tabs-wrap">
      {items.map((item, index) => (
        <S.ActionTabsItem
          disabled={disabled}
          key={item.label}
          onClick={() => handleSelected(index.toString(), item.onClick)}
          className={index === +selected ? 'active' : ''}
        >
          {item.label}
        </S.ActionTabsItem>
      ))}
    </S.ActionTabsWrap>
  )
}
